<template>
  <v-row>
    <v-col class="pt-0 pb-8">
      <p class="error--text">{{ $t('button.login.with') }}</p>
      <v-btn
        id="IdentityLoginButton"
        color="primary"
        class="pa-0"
        height="auto"
        outlined
        text
        @click="handleOnClick"
        ><v-img
          :src="require('@/assets/img/Digital Identity logo.jpg')"
          class="rounded"
          contain
      /></v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'IdentityLoginButton',
  methods: {
    handleOnClick() {
      this.$keycloak.login({
        redirectUri: `${location.origin}/signin/identity`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#IdentityLoginButton {
  &:hover {
    border-color: rgba(0, 0, 0, 8.7);
  }
}
</style>
